
export default function LoadingFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-4 border-teal-600 border-t-transparent"></div>
        <p className="mt-4 text-gray-600 text-sm">Đang tải...</p>
      </div>
    </div>
  );
}
